<template>
  <div class="page page-Team" :class="{ loaded: isLoaded}">

    <div class="content content--no-padding">

        <div class="team" @wheel="checkScrollY">
          <VuePerfectScrollbar class="scroll-area" :settings="scrollSettings" ref="membersScroll" @ps-scroll-x="checkScroll" :swicher="!isMobile">
            <div class="member-outer" v-for="(member, index) in team" :style="{'z-index': index + 1}" :class="memberOuterClass(member)">
              <div class="member" :class="{'member--open': member.open == true}">
                <div class="member__photo-block">
                  <div class="member__photo" :style="bgImgStyle(member.photos)"></div>
                </div>
                <div class="member__card" :class="memberCardClass(index)">
                  <div class="member__name-block glitch" @click="memberOpen(member)">
                    <div class="member__name magic"><span class="glitch-action" :data-text="member.name" v-html="member.name"></span></div>
                    <div class="member__lastname magic"><span class="glitch-action" :data-text="member.lastname" v-html="member.lastname"></span></div>
                    <div class="member__prof"><span class="glitch-action" :data-text="member.prof" v-html="member.prof"></span></div>
                  </div>

                  <div class="member__text">
                    <VuePerfectScrollbar class="scroll-area scroll-area--vertical" :settings="scrollSettingsMember">
                      <div class="member__preview" v-html="member.text.preview"></div>
                      <div class="member__info" v-html="member.text.info"></div>
                    </VuePerfectScrollbar>
                  </div>
                  <div class="member__btns glitch">
                    <span class="btn btn--big btn--square btn--gray" @click="memberClose(member)"><span><span class="glitch-action" :data-text="_('btnClose')">{{ _('btnClose') }}</span></span></span>
                  </div>
                </div>
              </div>
            </div>
          </VuePerfectScrollbar>
        </div>

      <div class="team-pagination" v-if="isMobile" :class="{hidden: teamPaginationHidden}">
        <div class="team-pagination__prev" @click="moveMember(-1)" :class="{disabled: currentMemberIndex == 0}">{{ _('btnPrevious') }}</div>
        <div class="team-pagination__next" @click="moveMember(1)" :class="{disabled: currentMemberIndex == team.length - 1}">{{ _('btnNext') }}</div>
      </div>

      <div class="scroll-left" @mouseover="scrollMembers(-1)" @mouseleave="scrollMembersLeave()" v-if="enableScrollLeft && !isMobile"></div>
      <div class="scroll-right" @mouseover="scrollMembers(1)" @mouseleave="scrollMembersLeave()" v-if="enableScrollRight && !isMobile"></div>

    </div>

  </div>
</template>

<script>
  import {loader} from '../mixins/loader';
  import {isMobile} from '../mixins/isMobile';
  import {functions} from '../mixins/functions';

  export default {
    name: 'Team',
    mixins: [loader, isMobile, functions],

    data() {
      return {
        pageData: {page: 'Team'},
        team: [],
        scrollSettings: {
            suppressScrollY: true,
        },
        scrollSettingsMember: {
          suppressScrollX: true,
        },
        customCursor: false,
        enableScrollLeft: false,
        enableScrollRight: true,
        scrollTimer: false,
        currentMemberIndex: 0,
        teamPaginationHidden: false
      }
    },

    deactivated() {
      this.isLoaded = false;
    },

    //activated() {
    mounted() {
      var _t = this;

      if (_t.$store.state.pagesLoaded.App && _t.$store.state.pagesLoaded.Team) {
        _t.onActivated();
      } else {
        //_t.$store.commit('loaderON');

        _t.$store.subscribe((mutation, state) => {
          if (mutation.type === 'pageLoaded' && mutation.payload.page == 'Team') {
            _t.onActivated();
          }
        });
      }
    },

    created(){
      this.$store.dispatch('loadData', {
        page: 'Team'
      });
    },

    methods: {
      onActivated() {
        let _t = this;
        _t.team = _t._('team');

        for (let i in _t.team) {
            _t.$set(_t.team[i], 'open', false);
            _t.$set(_t.team[i], 'prev', false);
            _t.$set(_t.team[i], 'next', i > 0);
        }

        _t.magic();
        _t.checkScroll();

        if (_t.imagesLoaded) {
          _t.pageLoaded();
        } else {
          var images = [];

          for (let i in _t.team) {
              for (let j in _t.team[i].photos) {
                  images.push(_t.team[i].photos[j]);
              }
          }

          _t.loadImages(images);
        }
      },
      magic: function () {
        var _t = this;

        _t.$nextTick(function () {
          $('.magic').each(function() {

              var el = $(this);

              while (el[0].scrollWidth > el[0].offsetWidth) {
                 el.css('font-size', (parseInt(el.css('font-size').slice(0, -2)) - 1) + 'px')
              }

              el.addClass('magic--finish');//.find('span').addClass('animate-letter-spacing');
          });
        });
      },
      memberOpen(member) {
          let _t = this;

          for (let i in _t.team) {
              _t.team[i].open = false;
          }

          member.open = true;
          _t.teamPaginationHidden = true;
      },
      memberClose(member) {
          member.open = false;
          this.teamPaginationHidden = false;
      },
      scrollMembers(delta) {
          let _t = this;

          _t.customCursor = delta > 0 ? 'right' : 'left';

          let jQueryElem = $(_t.$refs.membersScroll.$el);

          _t.scrollTimer = setInterval(function () {
              _t.checkScroll();

              if (delta > 0 && _t.enableScrollRight == false) {
                  _t.scrollMembersLeave();
                  return;
              }

              if (delta < 0 && _t.enableScrollLeft == false) {
                  _t.scrollMembersLeave();
                  return;
              }

              jQueryElem.scrollLeft(jQueryElem.scrollLeft() + delta);
          }, 10);
      },
      scrollMembersLeave() {
          let _t = this;
          _t.customCursor = false;
          clearInterval(_t.scrollTimer);

          _t.checkScroll();
      },
      checkScrollY(event) {

          let _t = this;
          let jQueryElem = $(_t.$refs.membersScroll.$el);

          jQueryElem.scrollLeft(jQueryElem.scrollLeft() + event.deltaY);

          _t.checkScroll();
      },
      checkScroll() {
          let _t = this;

          if (!_t.$refs.membersScroll) {
              return;
          }

          //left
          let scrollLeft = $(_t.$refs.membersScroll.$el).scrollLeft();

          if (scrollLeft == 0) {
              _t.enableScrollLeft = false;
          }
          if (scrollLeft > 0) {
              _t.enableScrollLeft = true;
          }

          //right
          let allWidth = parseInt($('.ps__scrollbar-x-rail').css('width'));
          let scrolledWidth = parseInt($('.ps__scrollbar-x').css('width')) + parseInt($('.ps__scrollbar-x').css('left'));

          if (allWidth != 0) {
              if (allWidth <= scrolledWidth) {
                  _t.enableScrollRight = false;
              }
              if (allWidth > scrolledWidth) {
                  _t.enableScrollRight = true;
              }
          }
      },
      memberCardClass(index) {

          if (this.isMobile) {
              return {'member__card--red': (index % 2 == 0)};
          }

          return {'member__card--red': (index % 3 == 0), 'member__card--blue': (index % 3 == 1)};
      },
      memberOuterClass(member) {
          let _t = this;

          if (!_t.isMobile) {
              return {};
          }

          return {'next': member.next == true, 'prev': member.prev == true};
      },
      moveMember(delta) {
          let _t = this;
          let membersCnt = _t.team.length;

          if ((delta < 0 && _t.currentMemberIndex == 0) || (delta > 0 && _t.currentMemberIndex == membersCnt - 1)) {
            return;
          }

          _t.currentMemberIndex += delta;

          for (let i in _t.team) {
              _t.team[i].open = false;

              if (i < _t.currentMemberIndex) {
                  _t.team[i].prev = true;
                  _t.team[i].next = false;
              }else if (i == _t.currentMemberIndex) {
                  _t.team[i].prev = false;
                  _t.team[i].next = false;
              }else if (i > _t.currentMemberIndex) {
                  _t.team[i].prev = false;
                  _t.team[i].next = true;
              }
          }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Team.vue